import { parseTitle } from '../../../utils/learnUtils';

const TAG_ELEMENTS = {
  chapter:    'h1',
  section:    'h2',
  subsection: 'h3',
};

/**
 * Renders an EDCOMP_TITLE content item.
 * @param {{ item: object }} props
 */
export default function TitleComp({ item }) {
  const { tag, name } = parseTitle(item.title);
  const level = item.data?.level ?? 'section';
  const Tag = TAG_ELEMENTS[level] ?? 'h3';
  const space = item.data?.space;

  const match_array = [...item?.title.matchAll(new RegExp("\\\\tag\\{([^\\}]*)\\}([\\s\\S]*)","gm"))]
  var title_id = ""
  var sec_chap_no = ""
  var title_name = ""
  try{
      sec_chap_no =  match_array[0][1]
      title_name = match_array[0][2]
      title_id = "id:"+sec_chap_no
  }
  catch{
      console.log("Didn't find tag")
  }

  const inner = (
    <>
      {tag && <span className="ct__title-tag">{tag}</span>}
      <span className="ct__title-name">{name}</span>
    </>
  );

  // Apply space on a div at body font-size so that em units resolve identically
  // to the frame__icons marginTop in FrameWrapper (which is also at body font-size).
  if (space !== undefined) {
    return (
      <div id={title_id} data-content-id={item._id} style={{ paddingTop: space }}>
        <Tag className={`ct__title ct__title--${level}`} style={{ paddingTop: 0 }}>
          {inner}
        </Tag>
      </div>
    );
  }

  return (
    <Tag id={title_id} data-content-id={item._id} className={`ct__title ct__title--${level}`}>
      {inner}
    </Tag>
  );
}
